import React from "react";
import useCanonical from "../../helper/useCanonical";
import aboutImg1 from "../../assets/about/about1.webp";
import aboutImg2 from "../../assets/about/about2.webp";
import aboutImg3 from "../../assets/about/about3.webp";
import Slider from "react-slick";
import bhartiyacorporate from "../../assets/about/ip/bhartiyacorporate.jpg";
import bollywoodcop from "../../assets/about/ip/bollywoodcop.jpg";
import bookofteenager from "../../assets/about/ip/bookofteenager.jpg";
import indianmemeboy from "../../assets/about/ip/indian.memeboy.jpg";
import indiapopculture from "../../assets/about/ip/indiapopculture.jpg";
import sadcasm from "../../assets/about/ip/sadcasm.jpg";
import sarcastic from "../../assets/about/ip/sarcastic.jpg";
import scrawledstories from "../../assets/about/ip/scrawledstories.jpg";
import scrollingculture from "../../assets/about/ip/scrollingculture.jpg";
import trollfuckers from "../../assets/about/ip/trollfuckers.jpg";
import xavierunclecoool from "../../assets/about/ip/xavierunclecoool.jpg";

const About = () => {
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className="slick_next slick-arrow" onClick={onClick}>
        <i className="bi bi-arrow-right"></i>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="slick_prev slick-arrow" onClick={onClick}>
        <i className="bi bi-arrow-left"></i>
      </div>
    );
  }

  var ipSliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    speed: 1500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useCanonical(
    "/about",
    "About Sarcasm: Global News Platform Covering Politics, Entertainment & Sports",
    "Learn about Sarcasm, a digital-first global news platform delivering trusted coverage on breaking news, politics, entertainment, sports, marketing, and trending stories."
  );
  return (
    <div>
      <section className="about-wrap-layout-2 space-top-60 space-bottom-60 space-top-md-30 space-bottom-md-30 bg-color-selago transition-default">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-box-layout-2">
                <div className="content-holder text-center">
                  <h2 className="entry-title color-dark-1-fixed">Who We Are</h2>
                  <p className="entry-description color-dark-1-fixed">
                    Sarcasm transforms humor into influence and memes into
                    marketing gold. We’re the masterminds behind 70 million
                    Facebook smiles and 12 million Instagram chuckles. Now,
                    we’re taking that power to help brands master the fine art
                    of being unforgettable online. Because memes aren’t just
                    funny—they’re effective.
                  </p>
                  <p className="entry-description color-dark-1-fixed mt-3">
                    At Sarcasm, we don’t just run the world’s largest meme
                    page—we’ve built an empire. With 50+ Instagram IPs boasting
                    a combined 300M followers and partnerships with 10,000 IPs
                    reaching over 1 billion fans, we’re like the Avengers of
                    social media (but funnier). Whether it’s memes, marketing,
                    or niche seeding, we’ve got the network to make your brand
                    go viral faster than a cat video.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-wrap-layout-2 space-top-60 space-bottom-60 space-top-md-30 space-bottom-md-30 bg-color-light-1 transition-default">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-box-layout-2">
                <div className="content-holder text-center w-100 aboutSrvcList">
                  <h2 className="entry-title color-dark-1-fixed">What We Do</h2>
                  <p className="entry-description color-dark-1-fixed">
                    What started as a meme marketing powerhouse has evolved into
                    a full-fledged marketing agency. At Sarcasm, we combine
                    creativity and strategy to deliver impactful campaigns
                    across platforms.
                  </p>
                  <p className="entry-description color-dark-1-fixed mt-2">
                    Our services include:
                  </p>
                  <div className="aboutSrvcList">
                    <ul>
                      <li>A-New-Age PR</li>
                      <li>ORM</li>
                      <li>Instagram Seeding</li>
                      <li>Facebook Seeding</li>
                      <li>X Trend & Seeding</li>
                      <li>Threads</li>
                      <li>UGC</li>
                      <li>Socials</li>
                      <li>DVC</li>
                      <li>Stunt Ideas</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-wrap-layout-2 space-top-60 space-bottom-60 space-top-md-30 space-bottom-md-30 bg-color-light-2 transition-default">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-box-layout-2">
                <div className="content-holder text-center w-100">
                  <h2 className="entry-title color-dark-1-fixed">SARCASM</h2>
                  <p className="entry-description color-dark-1-fixed">
                    Life’s too short for boring marketing. Let’s make it
                    memorable.
                  </p>
                </div>
              </div>
              <div className="aboutPageSlider">
                <Slider {...ipSliderSettings}>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/bhartiyacorporate/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={bhartiyacorporate} alt="bhartiyacorporate" />
                      </div>
                      <h4>bhartiyacorporate</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/bollywoodcop/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={bollywoodcop} alt="bollywoodcop" />
                      </div>
                      <h4>bollywoodcop</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/bookofteenager/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={bookofteenager} alt="bookofteenager" />
                      </div>
                      <h4>bookofteenager</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/indian.memeboy/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={indianmemeboy} alt="indianmemeboy" />
                      </div>
                      <h4>indianmemeboy</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/indiapopculture/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={indiapopculture} alt="indiapopculture" />
                      </div>
                      <h4>indiapopculture</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a href="https://www.facebook.com/Sadcasm/" target="_blank">
                      <div className="aboutPageSlideImg">
                        <img src={sadcasm} alt="sadcasm" />
                      </div>
                      <h4>sadcasm</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/sarcastic_us/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={sarcastic} alt="sarcastic" />
                      </div>
                      <h4>sarcastic_us</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/scrawledstories/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={scrawledstories} alt="scrawledstories" />
                      </div>
                      <h4>scrawledstories</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/scrollingculture/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={scrollingculture} alt="scrollingculture" />
                      </div>
                      <h4>scrollingculture</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/trollfuckers/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={trollfuckers} alt="trollfuckers" />
                      </div>
                      <h4>trollfuckers</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.instagram.com/xavierunclecoool/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={xavierunclecoool} alt="xavierunclecoool" />
                      </div>
                      <h4>xavierunclecoool</h4>
                    </a>
                  </div>
                  <div className="aboutPageSlideBox">
                    <a
                      href="https://www.facebook.com/SarcasmLol/"
                      target="_blank"
                    >
                      <div className="aboutPageSlideImg">
                        <img src={sarcastic} alt="sarcastic" />
                      </div>
                      <h4>Sarcasm Facebook</h4>
                    </a>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-wrap-layout2 space-top-50 bg-color-light-1 transition-default">
        <div className="container">
          <div className="section-heading heading-style-10">
            <h2 className="title">Sarcasm Group by Numbers</h2>
          </div>
          <div className="aboutNumber">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <div className="aboutNumberBox">
                  <h1>
                    20
                    <small>B</small>
                  </h1>
                  <h4>views per month from all the page</h4>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <div className="aboutNumberBox">
                  <h1>
                    200
                    <small>M</small>
                  </h1>
                  <h4>Total followers, all platforms combined </h4>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <div className="aboutNumberBox">
                  <h1>
                    10
                    <small>K</small>
                  </h1>
                  <h4>Partner Profiles</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const teamMembers = [
  {
    name: "Georges Embolo",
    designation: "Publisher",
    image: "../../assets/team/team4.webp",
    social: [
      { platform: "pinterest", link: "#" },
      { platform: "twitter", link: "#" },
      { platform: "mail-fast", link: "#" },
    ],
  },
  {
    name: "Nayah Tantoh",
    designation: "Publisher",
    image: "../../assets/team/team5.webp",
    social: [
      { platform: "pinterest", link: "#" },
      { platform: "twitter", link: "#" },
      { platform: "mail-fast", link: "#" },
    ],
  },
  {
    name: "John Philipe",
    designation: "Publisher",
    image: "a../../assets/team/team6.webp",
    social: [
      { platform: "pinterest", link: "#" },
      { platform: "twitter", link: "#" },
      { platform: "mail-fast", link: "#" },
    ],
  },
];

export default About;
